export default "__VITE_ASSET__f536070a__"